import { Input } from '@platform/design-system';
import { useTranslation } from '@platform/i18n';
import { useFormContext } from 'react-hook-form';
import { DIMENSION_FIELDS, type ProductFormValues } from '../product-form.ts';
import { useFieldError } from './sections.ts';
import { EditorSectionCard } from './EditorSectionCard.tsx';
import styles from './ProductEditor.module.css';

export const ShippingSection = () => {
  const { t } = useTranslation();
  const { register, formState } = useFormContext<ProductFormValues>();
  const errorText = useFieldError();
  return (
    <EditorSectionCard section="shipping">
      <div className={styles['dimensions']}>
        <Input
          label={t('productEditor.weight')}
          suffix={t('productEditor.unitKg')}
          inputMode="decimal"
          dir="ltr"
          errorText={errorText(formState.errors.weightKg)}
          {...register('weightKg')}
        />
        {DIMENSION_FIELDS.map((field) => (
          <Input
            key={field}
            label={t(`productEditor.${field}`)}
            suffix={t('productEditor.unitCm')}
            inputMode="decimal"
            dir="ltr"
            errorText={errorText(formState.errors[field])}
            {...register(field)}
          />
        ))}
      </div>
      <p className={styles['help']}>{t('productEditor.weightHelp')}</p>
    </EditorSectionCard>
  );
};
